export const ENDPOINTS_WORKFLOWS = {
  GET_ALL: "/api/workflows",
  GET_BY_ID: (workflowId: number) => `/api/workflows/${workflowId}`,
  POST_WORKFLOW: "/api/workflows",
  PUT_WORKFLOW: (workflowId: number) => `/api/workflows/${workflowId}`,
  DELETE_WORKFLOW: (workflowId: number) => `/api/workflows/${workflowId}`,
};

export const ENDPOINTS_WORKFLOW_STEPS = {
  GET_ALL: "/api/workflow-steps",
  GET_BY_ID: (stepId: number) => `/api/workflow-steps/${stepId}`,
  GET_BY_WORKFLOW_ID: (workflowId: number) => `/api/workflow-steps/workflows/${workflowId}`,
  POST_WORKFLOW_STEP: "/api/workflow-steps",
  PUT_WORKFLOW_STEP: (stepId: number) => `/api/workflow-steps/${stepId}`,
  DELETE_WORKFLOW_STEP: (stepId: number) => `/api/workflow-steps/${stepId}`,
};

export const ENDPOINTS_WORKFLOW_PROJECTS = {
  GET_ALL: "/api/workflow-projects",
  GET_BY_ID: (workflowProjectId: number) => `/api/workflow-projects/${workflowProjectId}`,
  GET_BY_WORKFLOW_ID: (workflowId: number) => `/api/workflow-projects/workflow/${workflowId}`,
  GET_BY_PROJECT_ID: (projectId: number) => `/api/workflow-projects/project/${projectId}`,
  POST_WORKFLOW_PROJECT: "/api/workflow-projects",
  PUT_WORKFLOW_PROJECT: (workflowProjectId: number) => `/api/workflow-projects/${workflowProjectId}`,
  DELETE_WORKFLOW_PROJECT: (workflowProjectId: number) => `/api/workflow-projects/${workflowProjectId}`,
};


export const ENDPOINTS_WORKFLOW_PROJECT_ACTIONS = {
  // Récupérer le label du bouton “Next” pour la prochaine étape
  GET_NEXT_BUTTON: (projectId: number) => `/api/workflow/projects/${projectId}/next-step`,
  // Créer le workflow_project pour la prochaine étape
  CREATE_NEXT_STEP: (projectId: number) => `/api/workflow/projects/${projectId}/validate-next-step`,
  // Récupérer le label du bouton “Back” pour l’étape précédente
  GET_BACK_BUTTON: (projectId: number) => `/api/workflow/projects/${projectId}/back-step`,
  // Créer le workflow_project pour l’étape précédente
  CREATE_BACK_STEP: (projectId: number) => `/api/workflow/projects/${projectId}/validate-back-step`,

};

export const ENDPOINTS_WORKFLOW_STEP_USERTYPES = {
  GET_ALL: "/api/workflow_step_usertypes",
  GET_BY_USERTYPE_ID: (usertypeId: number) => `/api/workflow_step_usertypes/usertype/${usertypeId}`,
  GET_BY_STEP_ID: (stepId: number) => `/api/workflow_step_usertypes/step/${stepId}`,
  CREATE: "/api/workflow_step_usertypes",
  UPDATE: (id: number) => `/api/workflow_step_usertypes/${id}`,
  DELETE: (id: number) => `/api/workflow_step_usertypes/${id}`,
};
